import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';
import ReactPiwik from 'react-piwik';

import theme from 'defaultTheme';

import Store from 'components/Store';
import Street from 'components/Street';
import InfoIcon from 'components/InfoIcon';
import Loading from 'components/Loading';
import SwitchViewButton from 'components/SwitchViewButton';

import ClothingStoreConfig from 'config/ClothingStoreConfig';
import FoodStoreConfig from 'config/FoodStoreConfig';
import MachineRoomConfig from 'config/MachineRoomConfig';

const VIEW_INIT = 'INIT';
const VIEW_STREET = 'STREET';
const VIEW_FOOD = 'FOOD';
const VIEW_CLOTHING = 'CLOTHING';
const VIEW_MACHINES = 'MACHINES';

if (process.env.NODE_ENV === 'production') {
// eslint-disable-next-line no-new
  new ReactPiwik({
    url: 'piwik.outermedia.de/piwik',
    siteId: 64,
    trackErrors: true,
  });
} else {
// eslint-disable-next-line no-new
  new ReactPiwik({
    url: 'piwik.outermedia.de/piwik',
    siteId: 32,
    trackErrors: true,
  });
}


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      view: VIEW_INIT,
      loading: true,
      streetPosition: null,
      scrollMode: 'horizontal',
    };

    document.body.classList.add(this.state.scrollMode);
  }

  componentWillMount() {
    window.addEventListener('load', () => (this.setState({ loading: false })));

    window.addEventListener('keydown', (event) => {
      // currently does not react to switching the scrollMode
      const scrollPos = window.pageXOffset || document.body.scrollLeft;
      const scrollDelta = 60; // not sure if we should calculate this depending on the height

      switch (event.keyCode) {
        case 65: // a key
        case 37: // left arrow key
          window.scrollTo(scrollPos - scrollDelta, 0);
          break;
        case 68: // d key
        case 39: // right arrow key
          window.scrollTo(scrollPos + scrollDelta, 0);
          break;
        case 32: // space key
          window.scrollTo(scrollPos + 400, 0);
          break;
      }
    }, false);
  }

  componentDidMount() {
    ReactPiwik.push(['trackPageView']);
  }

  exitStore = () => {
    this.setState({ view: VIEW_STREET });
  }

  enterClothingStore = () => {
    this.setState({ view: VIEW_CLOTHING });
  }

  enterFoodStore = () => {
    this.setState({ view: VIEW_FOOD });
  }

  enterMachinesRoom = () => {
    this.setState({ view: VIEW_MACHINES });
  }

  saveScrollPosition = (pos) => {
    this.setState({ streetPosition: pos });
  }

  renderView = () => {
    switch (this.state.view) {
      case VIEW_INIT: {
        return (
          <Street
            onEnterClothingStore={this.enterClothingStore}
            onEnterFoodStore={this.enterFoodStore}
            onEnterMachinesRoom={this.enterMachinesRoom}
            showIntro
            centerOnInit
            savePosition={this.saveScrollPosition}
            scrollMode={this.state.scrollMode}
          />
        );
      }
      case VIEW_FOOD:
        return <Store config={FoodStoreConfig} onExit={this.exitStore} scrollMode={this.state.scrollMode} />;
      case VIEW_CLOTHING:
        return <Store config={ClothingStoreConfig} onExit={this.exitStore} scrollMode={this.state.scrollMode} />;
      case VIEW_MACHINES:
        return <Store config={MachineRoomConfig} onExit={this.exitStore} scrollMode={this.state.scrollMode} />;
      default:
        return (
          <Street
            onEnterClothingStore={this.enterClothingStore}
            onEnterFoodStore={this.enterFoodStore}
            onEnterMachinesRoom={this.enterMachinesRoom}
            position={this.state.streetPosition}
            savePosition={this.saveScrollPosition}
            scrollMode={this.state.scrollMode}
          />
        );
    }
  }

  render() {
    return (
      <div>
        <Helmet
          titleTemplate="Virtuelle Marktstrasse"
          defaultTitle="Virtuelle Marktstrasse"
        >
          <html lang="de" />
          <meta name="description" content="Virtuelle Marktstrasse" />
          <meta name="keywords" content="Virtuelle Marktstrasse" />
        </Helmet>

        <ThemeProvider theme={theme}>
          <div>
            {this.renderView()}
            <Loading show={this.state.loading} />
          </div>
        </ThemeProvider>
        <InfoIcon />

        {[VIEW_INIT, VIEW_STREET].includes(this.state.view) &&
          <div style={{ position: 'relative', zIndex: 1 }}>
            <SwitchViewButton label="Zurück zur Homepage" linkTo="https://www.hde-klimaschutzoffensive.de/" center isExit />
          </div>
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js